import React from 'react';
import { SharedHero } from '@hover/shared-components';
import { StaticImage } from 'gatsby-plugin-image';
import { Layout, UtilityMenuBanner } from '../../v2/components/common';
import HoverPros from '../../v2/components/common/solutions/hoverPros';
import {
  ESTIMATE_AND_CLOSE_NUMBERS_POINTS,
  ESTIMATE_AND_CLOSE_PROPOSALS_POINTS,
  ESTIMATE_AND_CLOSE_PROS,
  ESTIMATE_AND_CLOSE_RESOURCES,
  ESTIMATE_AND_CLOSE_TESTIMONIES,
  ESTIMATE_AND_CLOSE_VISUALLY_SELECT_POINTS,
  ESTIMATE_IMPROVEMENT_PARTNERS,
} from '../../v2/constants/estimate-and-close';
import SolutionsTestimony from '../../v2/components/common/solutions/testimony/Testimony';
import Points from '../../v2/components/common/solutions/pointsList';
import StartToday from '../../v2/components/common/start-today';
import PartnerList from '../../v2/components/common/solutions/partnerList';
import ComparisonTable from '../../v2/components/common/solutions/comparisonTable';
import { URLS } from '../../v2/constants';
import Resources from '../../v2/components/common/solutions/resources';

const EstimateAndClosePage = () => (
  <Layout
    title="Roofing & Siding Estimate App"
    description="Accurate estimates for a fast close. With HOVER every sales representative can quote profitable siding and roofing jobs quickly and with confidence, protecting margin on every job."
    buttonType="SCHEDULE_A_DEMO"
    navbarDownloadAppURL={URLS.estimateClose.chatWithARep}
    bannerElement={<UtilityMenuBanner />}
  >
    <SharedHero
      page="estimate-and-close"
      bgColor="primary.100"
      eyebrow="HOVER ESTIMATES"
      heading="Accurate estimates for a fast close."
      body="With HOVER every sales representative can quote profitable siding and roofing jobs quickly and with confidence, protecting margin on every job."
      openModalButtonTitle="GET A DEMO"
      py={8}
      openModalButtonLink={URLS.estimateClose.getADemo}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/estimate-and-close_hero.png"
          alt=""
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/estimate-and-close_hero.png"
          alt=""
        />
      }
      justifyItems="center"
    />
    <HoverPros
      title="Customized to your business"
      items={ESTIMATE_AND_CLOSE_PROS}
    />
    <SolutionsTestimony items={ESTIMATE_AND_CLOSE_TESTIMONIES} />
    <Points
      items={ESTIMATE_AND_CLOSE_VISUALLY_SELECT_POINTS}
      isReversed
      heading="Visually select project scope"
      url={URLS.estimateClose.getADemo}
      urlTitle="GET A DEMO"
      image={
        <StaticImage
          src="../../v2/assets/images/estimate-and-close_points_1.jpg"
          alt=""
        />
      }
    />
    <Points
      items={ESTIMATE_AND_CLOSE_NUMBERS_POINTS}
      heading="Numbers crunched for you"
      url={URLS.estimateClose.getADemo}
      urlTitle="GET A DEMO"
      image={
        <StaticImage
          src="../../v2/assets/images/estimate-and-close_points_2.jpg"
          alt=""
        />
      }
    />
    <Points
      items={ESTIMATE_AND_CLOSE_PROPOSALS_POINTS}
      heading="One-click proposals with digital signatures"
      isReversed
      url={URLS.estimateClose.getADemo}
      urlTitle="GET A DEMO"
      image={
        <StaticImage
          src="../../v2/assets/images/estimate-and-close_points_3.jpg"
          alt=""
        />
      }
    />
    <PartnerList
      partners={ESTIMATE_IMPROVEMENT_PARTNERS}
      heading="The most trusted names in home improvement trust HOVER for Estimates."
      desktopRows={5}
    />
    <ComparisonTable
      heading="As simple as pricing per square and more accurate than error-prone spreadsheets"
      table={
        <StaticImage
          src="../../v2/assets/images/estimate-and-close_table.png"
          alt="TBD"
        />
      }
    />
    <Resources items={ESTIMATE_AND_CLOSE_RESOURCES} />
    <StartToday
      heading="Protect profitability on every job "
      body="Empower your entire team to build accurate estimates and close more jobs with confidence."
      cta={{
        label: 'GET A DEMO',
        href: URLS.estimateClose.getADemo,
      }}
    />
  </Layout>
);

export default EstimateAndClosePage;
